import fetch from "auth/FetchInterceptor";
import { ApiConstant } from "constants/ApiConstant";
import Utils from "utils";

const PackageService = {};

PackageService.getPackages = function (params) {
  return fetch({
    url: ApiConstant.PACKAGE_LIST,
    method: "get",
    params: Utils.filterHeaderParams(params),
  });
};
PackageService.downalodExcel = function (data, params) {
  const ids = Array.isArray(data) ? data : [data];
  return fetch({
    url: ApiConstant.PACKAGE_EXCEL_DOWNLOAD,
    method: "PATCH",
    params: Utils.filterHeaderParams(params),
    data: { ids }
  });
};
PackageService.addPackage = function (data, params) {
  console.log("Adding pose with data:", data);
  console.log("Params for adding pose:", params);
  return fetch({
    url: ApiConstant.PACKAGE_CREATE,
    method: "POST",
    params: Utils.filterHeaderParams(params),
    data: data,
  });
};
PackageService.editPackage = function (params, data) {
  return fetch({
    url: ApiConstant.PACKAGE_UPDATE,
    method: "PUT",
    params: Utils.filterHeaderParams(params),
    data: data,
  });
};
PackageService.editPackageStatus = function (data, status) {
  const payload = {
    status: status,
    package_ids: Array.isArray(data) ? data : [data],
  };
  return fetch({
    url: ApiConstant.PACKAGE_STATUS_UPDATE,
    method: "PUT",
    data: payload,
  });
};
PackageService.getSinglePackage = function (params) {
  return fetch({
    url: ApiConstant.PACKAGE_DETAILS,
    method: "get",
    params: Utils.filterHeaderParams(params),
  });
};

export default PackageService;
